module.exports = __webpack_public_path__ + "static/img/purple.2adf7ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yeti_page/purple.jpg
// module id = IeXA
// module chunks = 1